import React from 'react';
import { motion } from 'framer-motion';

// Springs, not fixed-duration tweens, so anything in flight can be
// interrupted and re-targeted from where it is on screen.
// bounce 0 = critically damped (default for UI); a little bounce is
// reserved for things the user flicks or throws.
export const spring = {
  ui: { type: 'spring', bounce: 0, duration: 0.4 },
  sheet: { type: 'spring', bounce: 0.15, duration: 0.35 },
  reveal: { type: 'spring', bounce: 0, duration: 0.8 },
};

// Fades content up into place the first time it scrolls into view.
// MotionConfig reducedMotion="user" (in App) drops the movement and
// keeps the fade for people who ask for less motion.
export function Reveal({ as = 'div', delay = 0, y = 24, className, children, ...props }) {
  const Component = motion[as];
  return (
    <Component
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '0px 0px -12% 0px' }}
      transition={{ ...spring.reveal, delay }}
      {...props}
    >
      {children}
    </Component>
  );
}

export function Arrow({ className = 'h-4 w-4' }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M3 8h9.5M8.5 4l4 4-4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
